import {
  projectNamePath,
  type ProjectRenameResponse,
} from '@cortex/domain-project-intake-contract';
import { request } from './_request.js';

/**
 * 案件名の変更 API クライアント。
 *
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business 母票の Backlog 件名と案件 Slack チャンネル名をまとめて変える API クライアント
 * @graph-connects /projects/{issueKey}/name [calls, via:PATCH] 案件名の変更
 */
export const projectRenameApi = {
  /** 案件名を変える（Slack は部分成功のことがあるので結果をそのまま返す）。 */
  rename: async (issueKey: string, summary: string): Promise<ProjectRenameResponse> =>
    request<ProjectRenameResponse>(projectNamePath(issueKey), {
      method: 'PATCH',
      body: JSON.stringify({ summary }),
    }),
};
